import React from 'react';
import PropTypes from 'prop-types';

import http from 'api/http';
import { trailerAPI } from 'api/requests';

import { ACTION } from 'constants/index';
import { STATUS } from 'constants/index';

import NotificationManager from 'dom-managers/notification';

import Modal from 'Components/Modal';
import Select, { selectType } from 'Components/Select';
import Button, { buttonColor, buttonType } from 'Components/Button';

export default class Row extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isModalOpen: false,
      requestInProcess: false,
    };

    this.$modalBody = '';
    this.$confirmModalAction = () => {};
  }

  _getRowState = () => {
    const {expandedRowId, trailer} = this.props;

    return (expandedRowId === trailer.id) ? 'expanded' : 'collapsed';
  };

  _getStatusColor = () => {
    const {trailer} = this.props;

    if (trailer && trailer.status) {
      return `list-scene__status-label_${trailer.status.toString().toLowerCase()}`;
    }
    return '';
  };

  _getTrailerReadableStatus = () => {
    const {trailer} = this.props;

    if (trailer && trailer.status) {
      return trailer.status[0].toUpperCase() + trailer.status.slice(1).toLowerCase();
    }

    return '';
  };

  _getTextColourStyle = key => {
    const {sortedBy} = this.props;

    if (sortedBy === key) return 'active';
    return '';
  };

  _getBackgroundColourStyle = () => {
    const {isOdd} = this.props;

    return isOdd ? '_background_color_pale_gray' : '_background_color_white';
  };

  _getAdditionalRowStyles = trailerId => {
    const {expandedRowId} = this.props;
    return expandedRowId === trailerId ? '_height_60' : '_height_0';
  };

  _selectAction = value => {
    const {selectTrailer, trailer} = this.props;

    switch (value) {
      case ACTION.ROLL_OVER:
        this.$modalBody = 'Are you sure you want to roll the trailer over?';
        this.$confirmModalAction = this._confirmRollOver;
        break;
      case ACTION.EDIT:
        return selectTrailer(trailer)();
      case ACTION.DEACTIVATE:
        this.$modalBody = 'Are you sure you want to Deactivate this application?';
        this.$confirmModalAction = this._confirmDeactivate;
        break;
      case ACTION.REACTIVATE:
        this.$modalBody = 'Are you sure you want to Reactivate this application?';
        this.$confirmModalAction = this._confirmReactivate;
        break;
      case ACTION.DELETE:
        this.$modalBody = 'Are you sure you want to Delete this application?';
        this.$confirmModalAction = this._confirmDelete;
        break;
      default:
        return null;
    }

    this.setState({isModalOpen: true});
  };

  _confirmDeactivate = () => {
    const {requestInProcess} = this.state;
    const {trailer, updateList} = this.props;

    if (requestInProcess) return null;

    this.setState({requestInProcess: true}, () => {
      http.put(trailerAPI.deactivate(trailer.id))
        .then(() => {
          NotificationManager.success(1, 'The status was updated successfully.');
        })
        .finally(() => {
          this._closeModal();
          updateList({...trailer, status: STATUS.DEACTIVATED});
        });
    });
  };

  _confirmReactivate = () => {
    const {requestInProcess} = this.state;
    const {trailer, updateList} = this.props;

    if (requestInProcess) return null;

    this.setState({requestInProcess: true}, () => {
      http.put(trailerAPI.reactivate(trailer.id))
        .then(() => {
          NotificationManager.success(1, 'The status was updated successfully.');
        })
        .finally(() => {
          this._closeModal();
          updateList({...trailer, status: STATUS.INCOMPLETE});
        });
    });
  };

  _confirmRollOver = () => {
    const {requestInProcess} = this.state;
    const {trailer, updateList} = this.props;

    if (requestInProcess) return null;

    this.setState({requestInProcess: true}, () => {
      http.post(trailerAPI.rollOver(trailer.id))
        .then(({data}) => {
          updateList({...data, isRollOver: true});
          NotificationManager.success(1, 'Your trailer has been successfully rolled over.');
        })
        .finally(() => {
          this._closeModal();
        });
    });
  };

  _confirmDelete = () => {
    const {requestInProcess} = this.state;
    const {trailer, updateList} = this.props;

    if (requestInProcess) return null;

    this.setState({requestInProcess: true}, () => {
      http.delete(trailerAPI.delete(trailer.id))
        .then(() => {
          NotificationManager.success(1, 'The trailer was deleted successfully.');
          this._closeModal();
          updateList({...trailer, status: null});
        })
        .catch(() => {
          this._closeModal();
        });
    });
  };

  _closeModal = () => {
    this.setState({isModalOpen: false, requestInProcess: false});
  };

  _getStringWithUnits = (value, units) => {
    if (value !== null || value !== undefined) {
      return units ? `${value.toString()} ${units}` : value.toString();
    }
    return '-';
  };

  _createActionsList = () => {
    const {trailer, currentModelYear, user} = this.props;
    const actions = [];

    actions.push(ACTION.ROLL_OVER);

    if (trailer.status !== STATUS.DEACTIVATED) {
      if (user.isInternal() || +trailer.year >= +currentModelYear) {
        actions.push(ACTION.EDIT);
      }

      if (user.isInternal() || (trailer.status === STATUS.APPROVED && +trailer.year >= +currentModelYear)) {
        actions.push(ACTION.DEACTIVATE);
      }
    }

    if (trailer.status === STATUS.DEACTIVATED) {
      if (user.isInternal() || +trailer.year >= +currentModelYear) {
        actions.push(ACTION.REACTIVATE);
      }
    }

    if (trailer.status === STATUS.INCOMPLETE || trailer.status === STATUS.DEACTIVATED) {
      actions.push(ACTION.DELETE);
    }

    return actions;
  };

  render() {
    const {isModalOpen, requestInProcess} = this.state;
    const {toggleRow, trailer, user} = this.props;

    return (
      <React.Fragment>
        <section
          id={`trailerRowId${trailer.id}`}
          className={`list-scene__expandable-row-wrapper list-scene__expandable-row-wrapper_${this._getRowState()}`}
        >
          <div
            className={`list-scene__table-row ${this._getBackgroundColourStyle()} _margin_bottom_0`}
            onClick={toggleRow(trailer.id)}
          >
            <div className={`list-scene__status-bar_left ${this._getStatusColor()}`} />

            <div className='list-scene__table-row-element list-scene__table-row-element_item-element _width_pc_8'>
              <div className={`list-scene__expand-icon list-scene__expand-icon_${this._getRowState()}`} />
            </div>

            <div
              id='trailerIdField'
              className={`list-scene__table-row-element list-scene__table-row-element_text-element
            ${this._getTextColourStyle('id')} _width_pc_12`}
            >
              {trailer.id}
            </div>

            <div
              id='trailerNameField'
              className={`list-scene__table-row-element list-scene__table-row-element_text-element
            ${this._getTextColourStyle('name')} _width_pc_50`}
            >
              {trailer.name}
            </div>

            <div className='list-scene__table-row-element list-scene__table-row-element_item-element _width_pc_12'>
              <div
                id='trailerStatusField'
                className={`list-scene__status-label ${this._getStatusColor()} ${this._getTextColourStyle('status')}`}
              >
                {this._getTrailerReadableStatus()}
              </div>
            </div>

            <div
              id='trailerActionsField'
              className='list-scene__table-row-element list-scene__table-row-element_item-element _width_pc_28'
            >
              {!user.isInspector() && (
                <Select
                  placeholder='Actions'
                  selectionList={this._createActionsList()}
                  handleSelect={this._selectAction}
                  defaultItem=''
                  isSlave
                  type={selectType.listActions}
                />
              )}
            </div>

            <div className={`list-scene__status-bar_right ${this._getStatusColor()}`} />
          </div>

          <div className={`list-scene__expandable-row list-scene__expandable-row_${this._getRowState()}`}>
            <div className='list-scene__expandable-row_column _width_20'>
              <div className='list-scene__expandable-row_column-header' />
              <div className='list-scene__expandable-row_column-body' />
            </div>

            <div className='list-scene__expandable-row_column'>
              <div className='list-scene__expandable-row_column-header'>Empty Trailer Weight</div>
              <div id='trailerWeightField' className='list-scene__expandable-row_column-body'>
                {this._getStringWithUnits(trailer.emptyTrailerWeight, 'Lbs.')}
              </div>
            </div>

            <div className='list-scene__expandable-row_column'>
              <div className='list-scene__expandable-row_column-header'>Over {'80"'} Wide</div>
              <div id='trailerOver9000Field' className='list-scene__expandable-row_column-body'>
                {trailer.over80Wide ? 'Yes' : 'No'}
              </div>
            </div>

            <div className='list-scene__expandable-row_column'>
              <div className='list-scene__expandable-row_column-header'>Coupler Rating w/o Brakes</div>
              <div id='trailerCouplerRatingField' className='list-scene__expandable-row_column-body'>
                {trailer.couplerRatingWithoutBrakes}
              </div>
            </div>

            <div className='list-scene__expandable-row_column'>
              <div className='list-scene__expandable-row_column-header'>Coupler Rating w/Brakes</div>
              <div id='trailerCouplerRatingWithBrakesField' className='list-scene__expandable-row_column-body'>
                {trailer.couplerRatingWithBrakes}
              </div>
            </div>

            <div className='list-scene__expandable-row_column'>
              <div className='list-scene__expandable-row_column-header'>Hook Rating</div>
              <div id='trailerHookRatingField' className='list-scene__expandable-row_column-body'>
                {trailer.hookRating}
              </div>
            </div>

            <div className='list-scene__expandable-row_column'>
              <div className='list-scene__expandable-row_column-header'>Rope/Strap Rating</div>
              <div id='trailerStrapRatingField' className='list-scene__expandable-row_column-body'>
                {trailer.strapRating}
              </div>
            </div>

            <div className='list-scene__expandable-row_column'>
              <div className='list-scene__expandable-row_column-header'>Axles</div>
              <div id='trailerNumberOfAxlesField' className='list-scene__expandable-row_column-body'>
                {trailer.numberOfAxles}
              </div>
            </div>

            <div className='list-scene__expandable-row_column'>
              <div className='list-scene__expandable-row_column-header'>Winch Rating</div>
              <div className='list-scene__expandable-row_column-body'>{trailer.winchRating}</div>
            </div>

            <div className='list-scene__expandable-row_column'>
              <div className='list-scene__expandable-row_column-header'>GAWR</div>
              <div id='trailerGAWRField' className='list-scene__expandable-row_column-body'>
                {this._getStringWithUnits(trailer.grossAxleWeightRating, 'Lbs.')}
              </div>
            </div>

            <div className='list-scene__expandable-row_column'>
              <div className='list-scene__expandable-row_column-header'>GVWR</div>
              <div id='trailerGVWRField' className='list-scene__expandable-row_column-body'>
                {this._getStringWithUnits(trailer.grossVehicleWeightRating, 'Lbs.')}
              </div>
            </div>

            <div className='list-scene__expandable-row_column'>
              <div className='list-scene__expandable-row_column-header'>Max Load Capacity</div>
              <div id='trailerLoadCapacityField' className='list-scene__expandable-row_column-body'>
                {this._getStringWithUnits(trailer.maxLoadCapacity, 'Lbs.')}
              </div>
            </div>

            <div className='list-scene__expandable-row_column _width_20'>
              <div className='list-scene__expandable-row_column-header' />
              <div className='list-scene__expandable-row_column-body' />
            </div>
          </div>
        </section>

        <Modal isOpen={isModalOpen}>
          <div className='ect-modal-header'>Confirmation</div>
          <div className='ect-modal-body'>{this.$modalBody}</div>
          <div className='ect-modal-footer'>
            <Button
              label='No'
              buttonClassName='_width_135 _height_40'
              onClick={this._closeModal}
              color={buttonColor.gray}
              type={buttonType.secondary}
            />
            <Button
              label='Yes'
              disabledWithSpinner={requestInProcess}
              buttonClassName='_width_135 _height_40'
              onClick={this.$confirmModalAction}
            />
          </div>
        </Modal>
      </React.Fragment>
    );
  }
}

Row.propTypes = {
  trailer: PropTypes.object.isRequired,
  isOdd: PropTypes.bool.isRequired,
  expandedRowId: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string
  ]),
  toggleRow: PropTypes.func,
  zIndex: PropTypes.number
};



// WEBPACK FOOTER //
// ./src/app/Scenes/TrailerManufacturer/List/Row.jsx